import React from "react";
import Preloader from "../helper/Preloader";
import Breadcrumb from "../components/UI/BreadcrumbMain";
import ShopSectionMain from "../components/UI/ShopSectionMain";
// import ShippingOne from "../components/ShippingOne";
import FooterOneMain from "../components/UI/FooterOneMain";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import HeaderOne from "../components/UI/HeaderOneMain";
import ShippingOneMain from "../components/UI/ShippingOneMain";
import BottomFooter from "../components/UI/BottomFooterMain";

const ProductCategorization = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#299E60" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOne category={false} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Product Categorization"} />

      {/* ShopSection */}
      <ShopSectionMain />

      {/* ShippingOne */}
      <ShippingOneMain />

      {/* FooterOneMain */}
      <FooterOneMain />
      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default ProductCategorization;
